<div class="map-container w-full bg-gray-400 relative" #mapContainer>

    <!-- Non Dispatch -->
    <div class="absolute ml-2 mt-2 w-96 z-10 bg-white rounded-lg" *ngIf="!isDispatch && !this.module">
      <div class="relative rounded-md shadow-lg">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <mat-icon
                class="m-0 mr-1 icon-size-5 text-indigo-600"
                [svgIcon]="'heroicons_outline:search'">
          </mat-icon>
        </div>
        <input googleMapsAutocomplete (autocompleteSelected)="onAutocompleteSelected($event)" [(ngModel)]="searchAll"
        type="text" name="map-search" id="map-search" class="flex-1 min-w-0 block w-full h-12 px-3 py-2 pl-10 pr-10 rounded-none rounded-l-md sm:text-sm border-indigo-300" placeholder="{{'placeholder.enter_address' | translate}}">
        <div class="absolute inset-y-0 right-0 pl-3 flex-1 items-center pt-2 pr-1" *ngIf="searchAll">
          <button mat-icon-button class="min-w-7 max-w-7 min-h-7 max-h-7" (click)="clearMapSearch()"><em class="ti ti-x close-mark text-xl"></em></button>
        </div>
      </div>
    </div>

    <!-- Dispatch -->
    <div class="relative z-10" *ngIf="isDispatch">
      <!-- Search and action buttons -->
      <div class="flex items-center w-full">
        <div class="w-full bg-transparent absolute top-0 right-0 z-99"  *ngIf="!drawOnMapNavbarData.toggleNavBar">
          <div class="px-4 py-2 flex items-center justify-between space-x-2 h-[60px]">
    
            <!-- Search -->
            <div
              class="p-2 h-12 min-w-fit flex items-start shadow-md rounded-3xl bg-white transition-[width] duration-300 ease-in-out"
              [ngClass]="mapSearchToggleState ? 'w-72' : 'w-12'">
    
              <!-- Search Icon/Loading  -->
              <div class="w-8 h-8 flex items-center justify-center flex-shrink-0">
                @if (_MapService.isNearByLoading()) {
                <button class="w-8 h-8 rounded-full cursor-pointer flex items-center justify-center hover:bg-gray-100"
                  (click)="!mapSearchToggleState ? toggleSearch(): null">
                  <output>
                    <svg aria-hidden="true" class="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                    </svg>
                    <span class="sr-only">Loading...</span>
                  </output>
                </button>
                } @else {
                <button
                  class="w-8 h-8 rounded-full cursor-pointer flex items-center justify-center hover:bg-gray-100 transition-colors"
                  title="{{'text.search.locations' | translate}}"
                  [ngClass]="{'pointer-events-none': mapSearchToggleState}"
                  (click)="!mapSearchToggleState ? toggleSearch(): null">
                  <i class="ti ti-search text-2xl"></i>
                </button>
                }
              </div>
    
              <!-- Search Input Container -->
              <div class="flex items-center h-8 overflow-hidden transition-[opacity,width] duration-300 ease-in-out"
                [ngClass]="mapSearchToggleState ? 'opacity-100 flex-1' : 'opacity-0 w-0'">
    
                <div class="flex items-center space-x-2 w-full pl-3">
                  <input type="text" placeholder="{{'placeholder.enter_address' | translate}}" googleMapsAutocomplete
                    #mapSearchInput (autocompleteSelected)="onAutocompleteSelected($event)" [(ngModel)]="searchAll"
                    autocomplete="off"
                    class="outline-none truncate flex-1 primary-font text-base font-normal text-gray-700 bg-transparent min-w-0 placeholder-gray-400"
                    (focusout)="toggleSearch()">
    
                  <!-- Clear Icon -->
                  <button type="button"
                    class="flex-shrink-0 w-8 h-8 rounded-full cursor-pointer flex items-center justify-center transition-all duration-200 hover:bg-gray-100"
                    [ngClass]="searchAll?.length ? 'opacity-100' : 'opacity-0'"
                    (click)="mapSearchInput.focus(); searchAll = ''; ">
                    <i class="ti ti-x text-2xl text-gray-500"></i>
                  </button>
                </div>
              </div>
            </div>
    
            <!-- Filter -->
            <ng-container>
              @if (_MapService.isNearByEnabled()) {
              <div class="relative flex-1 overflow-x-auto whitespace-nowrap flex items-center">
    
                <!-- Left Scroll Button -->
                @if (showLeftScrollButton) {
                <button
                  class="absolute left-0 z-99 bg-white p-2 rounded-full shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors"
                  (click)="filterScrollLeft()">
                  <i class="ti ti-chevron-left text-2xl"></i>
                </button>
                }
    
                <!-- Scrollable Filter Container -->
                <div id="filter-scroll-container" #filterScrollContainer
                  class="flex space-x-3 px-1 overflow-x-auto mx-4 scrollbar-none scroll-smooth flex-1 min-w-0 py-2"
                  (scroll)="checkFilterScrollButtons()">
    
                  <!-- Module Toggle Buttons -->
                  <fieldset
                    class="inline-flex rounded-lg shadow-md primary-font text-base font-normal text-gray-700 flex-shrink-0">
                    <button type="button" (click)="changeFilterModule('JOB')"
                      title="{{'job.quickfilter.header' | translate}}"
                      [ngClass]="selectedFilterModule === 'JOB' ? 'z-10 ring-2 ring-blue-700 text-blue-700 bg-blue-50' : 'text-gray-700 bg-white'"
                      class="inline-flex items-center space-x-2 px-3 py-2 border border-gray-200 rounded-s-lg hover:bg-gray-100 transition-colors primary-font text-base font-normal">
                      <i class="ti ti-briefcase text-2xl"></i>
                      <span>{{'text.jobs' | translate}}</span>
                    </button>
                    <button type="button" (click)="changeFilterModule('USER')"
                      title="{{'employee.quickfilter.header' | translate}}"
                      [ngClass]="selectedFilterModule === 'USER' ? 'z-10 ring-2 ring-blue-700 text-blue-700 bg-blue-50' : 'text-gray-700 bg-white'"
                      class="inline-flex items-center space-x-2 px-3 py-2 bg-white border-t border-b border-r rounded-e-lg border-gray-200 hover:bg-gray-100 transition-colors primary-font text-base font-normal">
                      <i class="ti ti-user text-2xl"></i>
                      <span>{{'text.users' | translate}}</span>
                    </button>
                  </fieldset>
    
                  <!-- Filter Options -->
                  @for (filter of filterOptions?.[selectedFilterModule]; track trackFilterBy($index, filter);) {
                  @if (filter?.canShow) {
                  <button (click)="onFilterBtnClick($event, filter)" [ngClass]="{
                                            'bg-blue-50 outline-blue-500 outline hover:bg-blue-100 outline-[1px] text-blue-600': filter?.isSelected, 
                                            'hover:bg-gray-100 bg-white text-gray-700': !filter?.isSelected
                                          }" [title]="filter?.isSelected ? (filter.displayName | translate) : ''"
                    class="px-3 py-2 whitespace-nowrap primary-font text-base font-normal flex items-center space-x-2 rounded-lg shadow-md flex-shrink-0 transition-colors">
    
                    @if (filter.icon) {
                    <i class="ti text-2xl" [ngClass]="filter.icon"></i>
                    }
                    <span>{{ filter?.formattedDisplayValue || filter?.displayName }}</span>
    
                    @if (filter?.isSelected) {
                    <i (click)="$event.stopPropagation(); $event.preventDefault(); onFilterClear(filter)"
                      title="{{'overall_search.recently_viewed.clear' | translate}}"
                      class="ti ti-x text-2xl rounded-md hover:text-blue-700 cursor-pointer"></i>
                    } @else {
                    @if (filter?.type !== 'BOOLEAN') {
                    <i class="ti ti-caret-down-filled text-2xl"></i>
                    }
                    }
                  </button>
                  }
                  }
                </div>
    
                <!-- Right Scroll Button -->
                @if (showRightScrollButton) {
                <button
                  class="absolute right-0 z-99 bg-white p-2 rounded-full shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors"
                  (click)="filterScrollRight()">
                  <i class="ti ti-chevron-right text-2xl"></i>
                </button>
                }
              </div>
              }
            </ng-container>
    
            <!-- Toolbar -->
            <div
              class="h-12 px-2 flex items-center shadow-md rounded-lg bg-white w-auto transition-[width] duration-400 ease-in-out space-x-2"
              [@easeInOutAnimation]>
              <!-- Map Filter Clear -->
              @if (filterCountData.count?.[selectedFilterModule]) {
              <div class="flex items-center" [@easeInOutAnimation]>
                <button (click)="clearAllFilters()" title="{{'text.clear_filter' | translate}}"
                  class="w-8 h-8 rounded-lg bg-blue-50 border border-blue-500 hover:bg-blue-100 text-blue-600 flex items-center justify-center transition-colors">
                  <i class="ti ti-filter-x text-2xl"></i>
                </button>
              </div>
              }
    
              <!-- Layer button -->
              <button
                class="w-8 h-8 rounded-lg hover:bg-gray-100 text-gray-600 flex items-center justify-center transition-colors"
                (click)="setOptionState()" [ngxTippy]="tooltip_template" [tippyProps]="tippyProps" title="{{'dispatchBoard.icons.tooltip.layers' | translate}}">
                <i class="ti ti-stack-2 text-2xl"></i>
              </button>
    
              <!-- Nearby toggle -->
              @if (_MapService.isNearByEnabled()) {
              <div class="bg-blue-600 text-white rounded-[6px] h-8 px-2 flex items-center gap-1 font-normal cursor-pointer"
                [@easeInOutAnimation]>
                <i class="ti ti-map-pin text-xl" title="{{'maps.nearby_mode' | translate}}"></i>
                <div class="h-4 w-px bg-white/25"></div>
                <i (click)="toggleNearBy()" class="ti ti-x text-xl" title="{{'maps.switch_off_nearby' | translate}}"></i>
              </div>
              }
            </div>
          </div>
        </div>
        <!-- Route job selection nav bar -->
        <div class="absolute top-0 z-10  h-18 border-b border-gray-300 bg-white flex justify-between w-full" *ngIf="drawOnMapNavbarData.toggleNavBar">
          <div class="flex items-center justify-center w-full mx-auto px-4">
            <div class="text-center">
              <span class="primary-font font-semibold">{{drawOnMapNavbarData.selectedJobs.length}} {{'jobs.selected' |
                translate}}</span>
            </div>
            <div class="flex ml-auto mr-2 order-2 space-x-4">
              <button type="button" (click)="clearDrawOnMap()"
                class="px-4 py-3 h-9 flex gap-2 cursor-pointer text-base items-center text-gray-700 border b-1 border-gray-300 shadow-xs font-medium rounded-md bg-white focus:outline-none btn-small">
                {{'cancel.text' | translate}}</button>
              <button type="button" (click)="createRouteOnDraw()"
                class="bg-primary text-base px-4 py-3 cursor-pointer h-9 w-max flex gap-2 items-center border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
                {{'route.create' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>


<!-- Nearby range selector -->
@if (_MapService.isNearByEnabled()) {
  <div class="absolute bottom-4 left-1/2 -translate-x-1/2 shadow-md min-w-fit w-4/12
        bg-white z-10 rounded-lg p-4 flex flex-col space-y-2 primary-font text-base text-gray-700 font-normal">
    <div class="flex items-center justify-between space-x-2">
      <label for="steps-range" class="font-medium text-gray-700">{{'maps.within_radius' | translate}}</label>
      <span class="text-gray-500">{{'maps.find_nearby_within' | translate}} {{nearbyConfig?.range.value}} {{nearbyConfig?.range?.unit}}</span>
    </div>
    <input id="steps-range" type="range" [min]="nearbyConfig?.range.min" [max]="nearbyConfig?.range.max"
      [value]="nearbyConfig?.range.value" list="nearby-values" step="1" (input)="onNearByRangeChange($event)"
      class="w-full h-3 rounded-lg cursor-pointer dark:bg-gray-700">
    <div class="datalist-wrapper">
      <datalist id="nearby-values">
        @for (i of nearbyConfig?.range.rangeList; track i) {
        <option class="cursor-pointer" [value]="i" [label]="i + ' ' + nearbyConfig?.range?.unit"
          (click)="updateNearByRadius(i);"></option>
        }
      </datalist>
    </div>
  </div>
}

<div id="map">
  <div class="px-2.5 py-2 rounded bg-blue-500 text-white text-center absolute shadow-md top-4 map-draw-float-btn z-999 w-fit primary-font text-base font-normal"
    *ngIf="floatingActionButton.showInfo && !floatingActionButton.showClearBtn">
    {{floatingActionButton.infoMessage}}
  </div>
  <div class="absolute px-2.5 py-2 rounded-3xl flex items-center space-x-2 font-medium shadow-md text-gray-700 bg-white text-center top-20 map-draw-float-btn z-999 w-fit primary-font text-base cursor-pointer"
   [ngClass]="!floatingActionButton.showClearBtn || floatingActionButton.showInfo ? 'hidden': ''" (click)="clearDrawOnMap(false, true)">
    <i class="ti ti-x text-2xl text-gray-400"></i>
    <span>{{'text.clear_selection' | translate}}</span>
  </div>
  <div class="ml-2 absolute bottom-2 tile-layer-parent">
    <span class="w-12 h-12 tile-layer-satellite cursor-pointer border-2 border-gray-500 shadow-md rounded-md" 
      *ngIf="currentTitleType === 'DEFAULT'" 
      title="{{'satellite.view' | translate}}" 
      (click)="setTileLayer('SATELLITE', $event)"></span>
    <span class="w-12 h-12 tile-layer-default cursor-pointer border-2 border-gray-500 shadow-md rounded-md"  
      *ngIf="currentTitleType === 'SATELLITE'"  
      title="{{'map.view' | translate}}"  
      (click)="setTileLayer('DEFAULT', $event)"></span>
  </div>
</div>

<preview-data [drawerOpen]="openDrawer" [module]="drawerModule" class="map-preview-data"
        [moduleUID]="moduleUid" [options]="previewOptions" (eventEmitter)="previewDataEventHandler($event)">
</preview-data>

<ng-template #tooltip_template let-hide>
  <div class="primary-font text-base text-gray-700">
    <div class="w-56 flex flex-col py-2">
      @for (option of pinOptions; track option) {
        @if (option?.showModule) {
          <div class="flex items-center justify-between hover:bg-gray-100 px-3 py-2.5">
            <label class="flex items-center w-full ml-0 cursor-pointer">
              <div class="w-8 flex justify-center">
                <i class="ti text-2xl" [ngClass]="option?.icon"></i>
              </div>
              <span class="font-normal ml-2 flex-1 select-none">
                {{option?.displayName | translate}}
              </span>
              <input type="checkbox"
                (change)="pinOptionChange(option.key)"
                [checked]="getPinValue(option.key)"
                class="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary ml-4 cursor-pointer">
            </label>
          </div>
        }
      }
      <div class="px-3 py-2">
        <button class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2.5 rounded-md transition-colors duration-200"
          type="button"
          (click)="savePinState()">
          {{'text.apply' | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<zuper-drawer
    class="territory-drawer absolute top-16 right-0"
    [fixed]="true"
    [mode]= "'side'"
    [name]="'legendDrawer'"
    [position]="'right'"
    [transparentOverlay]="false"
    [hideOnClickOutside]="false"
    >
    <div class="w-full h-full">
      <div class="fade h-full w-full">
         <div class="border-b border-gray-300 flex justify-between zuper-dialog-header">
           <div class="primary-font font-bold text-xl text-gray-700 flex items-center pl-2">
               {{'dispatchBoard.icons.tooltip.legend' | translate}}
           </div>
           <div class="flex justify-around">
               <a class="h-10 w-10 flex justify-center items-center hover:bg-gray-200 rounded-full cursor-pointer" (click)="closeLegendDrawer()">
                   <em class="ti ti-x text-gray-900 text-xl"></em>
               </a>
           </div>
         </div>
           
         <div class="bg-white primary-font p-6 legend-container overflow-auto zuper-scrollbar legend-container-scroll z-99">
           <div *ngFor="let territory of serviceTerritory" class="flex items-center mb-2">
            <span class="block rounded-full w-3 h-3 min-w-3 min-h-3" [ngStyle]="{'background': territory?.territory_color}"></span>
            <span class="ml-2 cursor-pointer" (click)="moveToTerritory(territory)">{{territory?.territory_name}}</span>
           </div>
           <div class="flex items-center justify-center w-full h-full" *ngIf="!serviceTerritory?.length">
              <span class="text-base font-normal">{{'no_data_found' | translate}}</span>
           </div>
         </div>

         <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer space-x-4">
            <button type="button" mat-stroked-button class="px-6 w-24 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none" (click)="closeLegendDrawer()">{{'close.text' | translate}}</button>
          
        </div>
       </div>
   </div>
</zuper-drawer>

<ng-template #routeAddJobConfirmationDialogContent let-hide let-data>
  <div mat-dialog-title
      class="primary-font flex justify-between border-b border-b-gray-300 zuper-dialog-header mb-0">
      <h2>{{'text.add_job_to.route' | translate}} - {{data?.selectedRoute?.route_name || ''}}</h2>
      <button mat-icon-button aria-label="close dialog" (click)="closeAddJobConfirmationDialog()" tabindex="-1">
          <mat-icon>close</mat-icon>
      </button>
  </div>
  <div
      class="w-full h-full overflow-y-auto zuper-scrollbar primary-font font-normal text-base text-gray-700">
      <div class="relative overflow-y-auto flex flex-col space-y-4 p-4">
          <div class="primary-font font-normal text-base text-gray-700">
            <span>{{'dispatchBoard.map.add_job_to_route.confirmation' | translate}} <span class="font-medium"></span>{{data?.selectedRoute?.route_name || ''}}</span>
          </div>

          <div class="flex flex-col space-y-4" *ngIf="data?.selectedJobs?.length">
            <span class="font-semibold">{{routeJobConfirmationDialogData.selectedJobCount}} {{'jobs.selected' | translate}}</span>
            <div class="max-h-72 overflow-y-auto zuper-scrollbar flex flex-col space-y-4 border rounded">
                <div class="text-base font-normal primary-font text-gray-700 flex flex-col">
                  <div class="flex items-center" *ngFor="let job of data?.selectedJobs; let i=index;" [ngClass]="{'border-b': i !== data?.selectedJobs?.length - 1 }">
                    <div class="p-3">
                      <input id="{{job?.job_uid}}" type="checkbox" (change)="addRouteJobSelectionChange($event, job)"
                        [checked]="routeJobConfirmationDialogData.jobs[job?.job_uid]"
                        class="h-4 w-4 mt-0.5 border-gray-300 text-indigo-600">
                    </div>
                    <label for="{{job?.job_uid}}" class="flex flex-col cursor-pointer w-full ml-2">
                      <div class="flex w-full">
                        <div class="flex items-center justify-between p-3 pl-0" style="width: 65% !important; max-width: 65% !important;">
                          <div class="flex items-center space-x-2 truncate">
                            <div class="block truncate flex-1 max-w-180" title="{{job?.name}}">{{job?.name || ''}}</div>
                            <div *ngIf="job?.current_job_status?.status_name && job?.current_job_status?.status_color"
                              [ngStyle]="{'border': '1px solid ' + job?.current_job_status?.status_color, 'background': job?.statusFadeColor }"
                              class="rounded-xl min-w-fit flex space-x-1 px-1.5 items-center flex-0">
                              <div class="w-2.5 h-2.5 rounded-full" [style.background]="job?.current_job_status?.status_color"></div>
                              <div [style.color]="job?.current_job_status?.status_color">{{job?.current_job_status?.status_name}}</div>
                            </div>
                          </div>
                          <div [innerHTML]="job?.assignedToAvatar | safeHtml: false" class="min-w-fit flex-0"></div>
                        </div>
                        <div class="border-l flex-0" style="width: 35% !important;">
                          <div class="flex space-x-2 p-3" title="{{'text.scheduled_date'| translate}}" *ngIf="!job?.showDueDate">
                            <i class="ti ti-calendar text-2xl" style="vertical-align: middle;"></i>
                            <span>
                              {{job?.startEndTime[0]}}
                              <i class="ti ti-arrow-right text-2xl" style="vertical-align: middle;"></i>
                              {{job?.startEndTime[1]}}
                            </span>
                          </div>
                          <div title="{{'text.due_by'| translate}}" class="flex items-center space-x-2 p-3" *ngIf="job?.showDueDate">
                            <i class="ti ti-calendar-due text-2xl"></i>
                            <div class="mt-0.5">{{job?.dueDate}}</div>
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
            </div>
        </div>
      </div>
  </div>
  <div
      class="flex justify-end border-t border-gray-300 zuper-dialog-footer primary-font font-normal text-base text-gray-700">
      <div class="flex justify-around space-x-4">
          <button type="button" (click)="closeAddJobConfirmationDialog()" [disabled]="isRouteMoveInProgress"
              class="px-6 items-center py-2 border b-1 border-gray-300 text-black shadow-sm text-lg font-small rounded-md bg-white focus:outline-none btn-small">
              {{'close.text' | translate}}</button>
          <button (click)="onRouteAddJobCompleted()" [disabled]="!routeJobConfirmationDialogData.selectedJobCount" [ngClass]="{'default-hover opacity-70 cursor-not-allowed': !routeJobConfirmationDialogData.selectedJobCount}"
              class="flex min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
              <span class="text-white">Add {{routeJobConfirmationDialogData.selectedJobCount}} {{routeJobConfirmationDialogData.selectedJobCount > 1? 'jobs': 'job'}} to route</span>
          </button>
      </div>
  </div>
</ng-template>

<ng-template #filterMenuContent let-filter="filter">
  <!-- Filter value -->
  <div class="min-w-fit min-h-fit p-4 flex flex-col space-y-4" [ngClass]="filter?.type === 'LOOKUP' ? 'max-h-72 overflow-y-auto zuper-scrollbar w-62 max-w-62 min-w-62' : 'w-56 max-w-56 min-w-56'">
    @switch (filter?.type) {
      @case ('DATE') {
        <div class="primary-font text-gray-700 text-base font-normal flex flex-col space-y-4 overflow-y-auto max-h-72 zuper-scrollbar">
          @for (dateOption of dateOptions; track dateOption.rangeKey;) {
          <div class="flex items-center space-x-2 primary-font text-gray-700 text-base font-normal" title="{{dateOption?.dateValueString}}">
            <input name="dateRange" id="{{dateOption?.rangeKey}}" type="radio" value="{{dateOption?.rangeKey}}" [(ngModel)]="filterInstanceData.filter.rangeKey"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 cursor-pointer focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
            <label class="cursor-pointer" for="{{dateOption?.rangeKey}}">{{dateOption?.key}}</label>
          </div>
          }
        </div>
      }
      @case ('LOOKUP') {
        <div class="primary-font text-gray-700 text-base font-normal flex flex-col space-y-4 overflow-y-auto zuper-scrollbar w-72 min-w-72 max-w-72" id="lookup-content-dropdown">
          <select-options [config]="filter?.lookupOptions" (selectionChange)="onSelectOptionChange($event)"></select-options>
        </div>
      }
    }
      <!-- Footer -->
    <div class="flex items-center justify-end space-x-2.5 pt-1 font-medium">
      <!-- Clear -->
      @if (filter?.selectedValue?.length) {
        <button class="text-base primary-font text-gray-700"
        (click)="onFilterClear()">{{'overall_search.recently_viewed.clear' | translate}}</button>
      }
      <button class="text-base primary-font text-blue-700" (click)="onFilterApply()">{{'apply.text.label' |
        translate}}</button>
    </div>
  </div>
</ng-template>

<app-new-job [openDrawer]="openJob" [jobData]="jobData" [jobObject]="jobObject"  (jobFormEmitter)="getJobFormResult($event)"></app-new-job>

<app-route-form [options]="routeFormOption" [openPicker]="openNewRoute" [data]="currentRoute" (actionComplete)="onNewActionComplete($event)" [showRouteAlert]="true" [parentModule]="isDispatch ? 'dispatch': ''" [timezone]="routeCreationTimezone"></app-route-form>